import type { ReactNode } from 'react'
import { Outlet } from 'react-router-dom'

import useStoreCurrentUser from '@app/hooks/useStoreCurrentUser'
import { useMapStructureUpdatedSubscription, useOrganizationCrudSubscription } from '@graphql/queries'

interface GraphqlSubscriptionShellProps {
  children?: ReactNode
  strategyId: string | null
}
const GraphqlSubscriptionShell = ({ children, strategyId }: GraphqlSubscriptionShellProps) => {
  const { user } = useStoreCurrentUser()

  const organizationId = user?.organization?.id
  useOrganizationCrudSubscription({
    variables: {
      organizationId
    },
    pause: !organizationId
  })
  useMapStructureUpdatedSubscription({
    variables: {
      strategyId
    },
    pause: !strategyId
  })

  return children || <Outlet />
}

export default GraphqlSubscriptionShell
